import BaseModel from '../core/BaseModel'

export default class CommunityBoardModel extends BaseModel {

    constructor() {
        super({
                name: "community_board",
                tableName: 'community_board_post',
                label: "Community board",
                display_key: 'title',
                default_order: { key: 'updated_at', direction: 'desc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    width: 5,
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                uid: {
                    name: 'uid',
                    type: "Uuid",
                    label: 'UID',
                    display: false
                },
                avatar: {
                    name: "avatar",
                    label: "Avatar",
                    custom: 'image',
                    type: "Computed",
                    computed: () => {
                    },
                    width: 8,
                },
                fullname: {
                    name: 'fullname',
                    type: "String",
                    label: 'Fullname',
                    filter: { type: 'input', match: 'contains' },
                    width: 14,
                },
                property_id: {
                    name: 'property_id',
                    type: "String",
                    label: 'Property ID',
                    filter: { type: 'input', match: 'contains' },
                    width: 10,
                },
                property_name: {
                    name: 'property_name',
                    type: "String",
                    label: 'Property',
                    filter: { type: 'input', match: 'contains' },
                    width: 14,
                },
                
                // title: {
                //     name: 'title',
                //     type: "String",
                //     label: 'Heading (Title)',
                //     filter: { type: 'input', match: 'contains' },
                //     width: 16,
                // },
                description: {
                    name: 'description',
                    type: "Text",
                    label: 'Description',
                   // filter: { type: 'input', match: 'contains' },
                    width: 18,
                },
                reply_count: {
                    name: 'reply_count',
                    type: "String",
                    label: 'Replies',
                    //filter: { type: 'input', match: 'contains' },
                    class: "center",
                    width: 8,
                },
                active: {
                    name: 'active',
                    type: "String",
                    custom: 'SelectionText',
                    label: 'Active',
                    width: 8,
                    class: "center",
                },
                updated_name: {
                    name: 'updated_name',
                    type: "String",
                    label: 'Updated by',
                    filter: { type: 'input', match: 'contains' },
                    width: 12,
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated date',
                    filter: { type: 'DateRange', match: 'contains' },
                    width: 12,
                },
            })
    }
}
